if ('serviceWorker' in navigator && location.hostname !== '127.0.0.1') {
	window.addEventListener('load', async () => {
		const registration = await navigator.serviceWorker.register('/sw.js')
		await registration.update()
	})
}

await import('./app.ts')

export {}
